/* ==========================================================
   horeca-facets.js
   Añadir en: Assets → horeca-facets.js
   Incluir con:
     <script src="{{ 'horeca-facets.js' | asset_url }}" defer></script>
   ========================================================== */

(function () {
  'use strict';

  /* ─── Selectores ─── */
  const FORM_ID        = 'FacetFiltersForm';
  const SEARCH_ID      = 'FacetSearch';
  const CLEAR_SEARCH   = 'ClearSearch';
  const FACETS_ID      = 'FacetsHoreca';
  const PRODUCT_GRID   = 'product-grid';        // ID del contenedor de productos en tema Trade
  const PRODUCT_COUNT  = 'ProductCountDesktop'; // ID del contador de productos en tema Trade
  const LOADING_CLASS  = 'horeca-facets--loading';

  /* ─── Helpers ─── */
  function getParams(form) {
    return new URLSearchParams(new FormData(form)).toString();
  }

  function setLoading(on) {
    const facets = document.getElementById(FACETS_ID);
    if (facets) facets.classList.toggle(LOADING_CLASS, on);
  }

  /* ─── Actualizar URL y productos sin recargar ─── */
  async function applyFilters(params) {
    setLoading(true);

    const url = `${window.location.pathname}?${params}`;

    try {
      const response = await fetch(url, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!response.ok) throw new Error('Network error');

      const html   = await response.text();
      const parser = new DOMParser();
      const doc    = parser.parseFromString(html, 'text/html');

      /* Actualizar cuadrícula de productos */
      const newGrid = doc.getElementById(PRODUCT_GRID);
      const curGrid = document.getElementById(PRODUCT_GRID);
      if (newGrid && curGrid) curGrid.innerHTML = newGrid.innerHTML;

      /* Actualizar panel de filtros (para counts actualizados) */
      const newFacets = doc.getElementById(FACETS_ID);
      const curFacets = document.getElementById(FACETS_ID);
      if (newFacets && curFacets) {
        curFacets.innerHTML = newFacets.innerHTML;
        bindEvents(); // re-bind eventos tras actualizar DOM
      }

      /* Actualizar contador de productos */
      const newCount = doc.getElementById(PRODUCT_COUNT);
      const curCount = document.getElementById(PRODUCT_COUNT);
      if (newCount && curCount) curCount.innerHTML = newCount.innerHTML;

      /* Actualizar URL sin recargar */
      history.pushState({}, '', url);

    } catch (error) {
      console.error('[HorecaFacets] Error al aplicar filtros:', error);
      window.location = url; // fallback: recarga normal
    } finally {
      setLoading(false);
    }
  }

  /* ─── Eventos ─── */
  function bindEvents() {

    /* Checkboxes → aplicar inmediatamente al hacer clic */
    document.querySelectorAll('.horeca-facets__checkbox').forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        const form = document.getElementById(FORM_ID);
        if (!form) return;
        applyFilters(getParams(form));
      });
    });

    /* Formulario (botón "Ver resultados" y "Aplicar precio") */
    const form = document.getElementById(FORM_ID);
    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        applyFilters(getParams(form));
      });
    }

    /* Selector de ordenamiento */
    const sortSelect = document.getElementById('SortBy');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        const form = document.getElementById(FORM_ID);
        const params = form
          ? getParams(form)
          : `sort_by=${sortSelect.value}`;
        applyFilters(params);
      });
    }

    /* Búsqueda con debounce */
    const searchInput = document.getElementById(SEARCH_ID);
    if (searchInput) {
      let debounceTimer;
      searchInput.addEventListener('input', () => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          const form = document.getElementById(FORM_ID);
          if (form) applyFilters(getParams(form));
        }, 400);
      });
    }

    /* Limpiar búsqueda */
    const clearBtn = document.getElementById(CLEAR_SEARCH);
    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        const input = document.getElementById(SEARCH_ID);
        if (input) {
          input.value = '';
          const form = document.getElementById(FORM_ID);
          if (form) applyFilters(getParams(form));
        }
      });
    }

    /* Filtros de precio: aplicar al presionar Enter */
    document.querySelectorAll('.horeca-facets__price-input').forEach((input) => {
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          const form = document.getElementById(FORM_ID);
          if (form) applyFilters(getParams(form));
        }
      });
    });

  }

  /* ─── Navegación hacia atrás/adelante del browser ─── */
  window.addEventListener('popstate', () => {
    const params = window.location.search.slice(1);
    applyFilters(params);
  });

  /* ─── Init ─── */
  document.addEventListener('DOMContentLoaded', bindEvents);

})();